import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Star } from "lucide-react";
import { LogoWhite } from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-fegray-dark text-white pt-20 pb-0 mt-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <LogoWhite size="md" className="mb-3" />
          <div className="text-xs tracking-[0.2em] lowercase mb-5">
            <span className="text-fegreen">stimulez votre </span>
            <span className="text-white/80">bien-être</span>
          </div>
          <p className="text-white/70 max-w-md leading-relaxed text-sm">
            Coach sportif spécialisée en électrostimulation et massages
            à domicile à Istres &amp; alentours. Profitez d&apos;un
            accompagnement personnalisé selon vos objectifs avec la
            technologie allemande MIHA BODYTEC.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href="https://www.facebook.com/people/Formelec/100086893831574/" target="_blank" rel="noreferrer" aria-label="Facebook FORM'ELEC" data-testid="footer-fb" className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-fegreen hover:border-fegreen transition">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="https://www.instagram.com/formelec_istres/" target="_blank" rel="noreferrer" aria-label="Instagram FORM'ELEC" data-testid="footer-ig" className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-fegreen hover:border-fegreen transition">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
          <div className="flex items-center gap-2 mt-5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-fegreen text-fegreen" />
            ))}
            <span className="text-sm text-white/80 ml-2">4.9/5 — 34 avis Google</span>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-base mb-4 text-fegreen">Navigation</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="text-white/70 hover:text-fegreen">À Propos</Link></li>
            <li><Link to="/tarifs" className="text-white/70 hover:text-fegreen">Nos Tarifs</Link></li>
            <li><Link to="/le-coach" className="text-white/70 hover:text-fegreen">Le Coach</Link></li>
            <li><Link to="/blog" className="text-white/70 hover:text-fegreen">Blog</Link></li>
            <li><Link to="/credit-impot" className="text-white/70 hover:text-fegreen">Crédit d&apos;impôt</Link></li>
            <li><Link to="/reservation" className="text-white/70 hover:text-fegreen">Réservation</Link></li>
            <li><Link to="/contact" className="text-white/70 hover:text-fegreen">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-base mb-4 text-fegreen">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3 text-white/70">
              <MapPin className="w-4 h-4 mt-0.5 text-fegreen flex-shrink-0" />
              <span>Istres &amp; Alentours<br />Bouches-du-Rhône (13)</span>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <Phone className="w-4 h-4 text-fegreen flex-shrink-0" /> 07 66 25 31 43
            </li>
            <li className="flex items-start gap-3 text-white/70 break-all">
              <Mail className="w-4 h-4 text-fegreen flex-shrink-0 mt-0.5" /> rosariveti@gmail.com
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} FORM&apos;ELEC — Tous droits réservés.</p>
        <div className="flex gap-6 flex-wrap">
          <Link to="/mentions-legales" className="hover:text-fegreen" data-testid="footer-mentions">Mentions légales</Link>
          <Link to="/cgv" className="hover:text-fegreen" data-testid="footer-cgv">CGV</Link>
          <Link to="/confidentialite" className="hover:text-fegreen" data-testid="footer-privacy">Politique de confidentialité</Link>
          <Link to="/admin/login" className="hover:text-fegreen text-white/30" data-testid="footer-admin-link">Espace pro</Link>
        </div>
      </div>

      {/* MSC AGENCY SIGNATURE */}
      <div className="bg-black/50 mt-8 py-5 border-t border-white/10" data-testid="msc-signature">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-center gap-3 text-[12px] text-white/70">
          <span>
            Réalisé par l&apos;
            <a
              href="https://agence-msc.fr"
              target="_blank"
              rel="noreferrer"
              aria-label="Visiter le site de l'Agence MSC"
              data-testid="msc-logo-link"
              className="font-bold text-white hover:text-fegreen transition-colors"
            >
              Agence MSC
            </a>
          </span>
          <a
            href="https://agence-msc.fr"
            target="_blank"
            rel="noreferrer"
            aria-label="Agence MSC"
            tabIndex={-1}
            className="inline-block"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_rosalie-coach-ems/artifacts/zqmnunxk_image.png"
              alt="Agence MSC"
              className="h-10 w-10 object-contain hover:scale-105 transition-transform"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
